import { withTranslation } from "react-i18next"

// Components
import Badges from "../Badges";
import ForOther from "./ForOther";


const quantities = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10
]

/**
 * Recipient
 * @param {*} props 
 * @returns 
 */
const Recipient = (props) => {
  const getTitle = () => {
    if (props.userSelection.category) {
      return (
        <>
          <div style={{ color: '#333', textAlign: 'center', fontSize: 24, fontWeight: 700 }}>{props.userSelection.category.title}</div>
          <div style={{ textAlign: 'center', fontSize: 16, marginTop: 10, marginBottom: 20 }}>{props.userSelection.category.description}</div>
        </>
      )
    }
    return (
      <div style={{ color: '#333', textAlign: 'center', fontSize: 26 }}>
        {`Bon d'achat ${props.userSelection.amount}€`}
      </div>
    )
  }

  return (
    <>
      <Badges 
        active={2}
        setCurrentView={props.setCurrentView}
      />

      {getTitle()}

      <div style={{ width: '90%', margin: 'auto' }}>
        <ForOther 
          quantities={quantities}
          setCurrentView={props.setCurrentView}
          setUserSelection={props.setUserSelection}
          userSelection={props.userSelection}
        />
      </div>
    </>
  )
}

export default withTranslation()(Recipient);